/* eslint-disable @typescript-eslint/no-explicit-any*/

import {
  SET_BILLET_REMIT,
  SET_PIX_REMIT,
  SET_TRANSFER_REMIT,
} from '../actions/actionTypes';

const initialState: reducers.TransactionRule = {
  billet: null,
  transfer: null,
  pix: null,
};

const remitReducer = (state = initialState, action: any) => {
  const { payload } = action;

  switch (action.type) {
    case SET_TRANSFER_REMIT:
      state = {
        ...state,
        transfer: payload,
      };
      break;

    case SET_BILLET_REMIT:
      state = {
        ...state,
        billet: payload,
      };
      break;

    case SET_PIX_REMIT:
      state = {
        ...state,
        pix: payload,
      };
      break;
    default:
      return state;
  }

  return state;
};

export default remitReducer;
